import { gql } from '@apollo/client';

import {
  GetQuestionMessagesDocument,
  type GetQuestionMessagesQuery,
  type GetQuestionMessagesQueryVariables,
} from '../__generated__/documents';

/**
 * Resume: the conversation the backend already holds for one question, in
 * order. A query rather than a mutation, so it is safe to re-issue on every
 * remount — which is what replaced the removed `openQuestion` round trip.
 *
 * `@unmask` on `...UnifiedMessage`: this query runs `fetchPolicy: 'no-cache'`,
 * so nothing here ever reaches the normalized cache — `client.readFragment`
 * (the masking-aware read) always misses. `@unmask` inlines the fragment
 * instead of masking it, matching the data this fetch policy actually
 * delivers.
 */
if (false) {
  gql`
    query GetQuestionMessages($insightId: UUID!, $questionId: UUID) {
      insightV2(id: $insightId) {
        id
        progress
        messages(questionID: $questionId) {
          ...UnifiedMessage @unmask
        }
      }
    }
  `;
}

export const GET_QUESTION_MESSAGES = GetQuestionMessagesDocument;
export type { GetQuestionMessagesQuery, GetQuestionMessagesQueryVariables };
